const PARTICULAR_PROPOSAL = {
  PARTICULAR_FREE: { name:'NIDO Esencial', standardAmount:0 },
  PARTICULAR_SIMPLE_M: { name:'NIDO Simple', standardAmount:54900, firstCycleAmount:27450 },
  PARTICULAR_SIMPLE_A: { name:'NIDO Simple anual', standardAmount:549000 },
  PARTICULAR_DESTACADO_M: { name:'NIDO Destacada', standardAmount:109900, firstCycleAmount:54950 },
  PARTICULAR_DESTACADO_A: { name:'NIDO Destacada anual', standardAmount:1099000 },
  PARTICULAR_SUPER_M: { name:'NIDO Máxima', standardAmount:179900, firstCycleAmount:89950 },
  PARTICULAR_SUPER_A: { name:'NIDO Máxima anual', standardAmount:1799000 },
  DESTAQUE_UNICO: { name:'Impulso NIDO', standardAmount:102090.12 },
};

const PROFESSIONAL_PROPOSAL = {
  PRO_5_SIMPLES_M: { name:'NIDO Inicio', standardAmount:109900 },
  PRO_5_SIMPLES_A: { name:'NIDO Inicio anual', standardAmount:1099000 },
  PRO_PACK_10_M: { name:'NIDO Profesional 10', standardAmount:149900 },
  PRO_PACK_10_A: { name:'NIDO Profesional 10 anual', standardAmount:1499000 },
  PRO_10_DESTACADOS_M: { name:'NIDO Pro', standardAmount:299900 },
  PRO_10_DESTACADOS_A: { name:'NIDO Pro anual', standardAmount:2999000 },
  PRO_5_SUPER_M: { name:'NIDO Máxima', standardAmount:449900 },
  PRO_5_SUPER_A: { name:'NIDO Máxima anual', standardAmount:4499000 },
  INDIVIDUAL_SIMPLE_M: { name:'1 Simple', standardAmount:29900 },
  INDIVIDUAL_DESTACADO_M: { name:'1 Destacado', standardAmount:64900 },
  INDIVIDUAL_SUPER_M: { name:'1 Superdestacado', standardAmount:199900 },
};

export function particularCommercialPlan(plan, accountType) {
  if (accountType !== 'PARTICULAR') return plan;
  const proposal = PARTICULAR_PROPOSAL[plan.code];
  if (!proposal) return plan;
  const firstCycleAmount = plan.billingPeriod === 'MONTHLY' ? proposal.firstCycleAmount : null;
  return {
    ...plan,
    name: proposal.name,
    amount: firstCycleAmount ?? proposal.standardAmount,
    originalAmount: proposal.standardAmount,
    offer: firstCycleAmount ? {
      name:'Lanzamiento NIDO · primer mes',
      discountPercent:50,
      firstCycleOnly:true,
    } : null,
  };
}

export function commercialPlan(plan, accountType) {
  if (accountType === 'PARTICULAR') return particularCommercialPlan(plan, accountType);
  if (accountType !== 'INMOBILIARIA') return plan;
  const proposal = PROFESSIONAL_PROPOSAL[plan.code];
  if (!proposal) return plan;
  const firstCycleAmount = plan.billingPeriod === 'MONTHLY' ? proposal.firstCycleAmount : null;
  return {
    ...plan,
    name: proposal.name,
    amount: firstCycleAmount ?? proposal.standardAmount,
    originalAmount: proposal.standardAmount,
    offer: firstCycleAmount ? {
      name:'Lanzamiento NIDO · primer mes',
      discountPercent:50,
      firstCycleOnly:true,
    } : null,
  };
}
